import { IAnalyticsSubmission } from '../types'

export enum SnapMetricsActionTypes {
  FETCH_REQUEST = 'pcr/snapMetrics/FETCH_REQUEST',
  FETCH_SUCCESS = 'pcr/snapMetrics/FETCH_SUCCESS',
  FETCH_ERROR = 'pcr/snapMetrics/FETCH_ERROR',
}

export interface ISnapMetricsState {
  isFetching: boolean
  errors?: object | string
  snapMetricsById: Record<number, ISnapMetrics>
  snapMetricIdsByCampaignId: Record<number, ReadonlyArray<number>>
  snapMetricsSummaryByCampaignId: Record<number, ISnapMetricsSummary>
}

export interface ISnapMetrics extends IAnalyticsSubmission {
  purchase_amount: number
  purchase_amount_currency: string
  impressions?: number
  impressions_pct?: number
  cpm?: number
  cpv?: number
  likes?: number
  comments?: number
  shares?: number
  engagement?: number
  cpe?: number
  engagement_pct?: number
}

export interface ISnapMetricsSummary {
  count: number | null
  total_purchase_amount: number | null
  total_followers: number | null
  engagement?: number
  engagement_pct?: number
  likes?: number
  comments?: number
  shares?: number
  impressions?: number
  impressions_pct?: number
  cpv?: number
  cpm?: number
  cpe?: number
}

export interface ISnapMetricsResponse {
  items: ReadonlyArray<ISnapMetrics>
  metadata: ISnapMetricsSummary
}
